import { api } from "./apiService";

/**
 * Test Run Service
 * Handles all API calls related to test runs
 */
export const testrunService = {
  /**
   * Create a new test run
   */
  createTestRun: async (testRunData) => {
    const response = await api.post("/testrun/create", testRunData);
    return response;
  },

  /**
   * Get test run by ID
   */
  getTestRun: async (testRunId, projectId) => {
    const response = await api.post("/testrun/get", {
      test_run_id: testRunId,
      project_id: projectId,
    });
    return response;
  },

  /**
   * List test runs for a project
   */
  listTestRuns: async (projectId, filters = {}) => {
    const response = await api.post("/testrun/list", {
      project_id: projectId,
      ...filters,
    });
    return response;
  },

  /**
   * Update test run
   */
  updateTestRun: async (testRunId, projectId, updates) => {
    const response = await api.post("/testrun/update", {
      test_run_id: testRunId,
      project_id: projectId,
      ...updates,
    });
    return response;
  },

  /**
   * Delete test run
   */
  deleteTestRun: async (testRunId, projectId) => {
    const response = await api.post("/testrun/delete", {
      test_run_id: testRunId,
      project_id: projectId,
    });
    return response;
  },

  /**
   * Get test cases for selection
   */
  getTestCasesForSelection: async (projectId, filters = {}) => {
    const response = await api.post("/testrun/test-cases", {
      project_id: projectId,
      ...filters,
    });
    return response;
  },

  /**
   * Update test case execution status in a test run
   */
  updateTestCaseExecution: async (
    testRunId,
    testRunCaseId,
    projectId,
    updates,
  ) => {
    const response = await api.post("/testrun/update-execution", {
      test_run_id: testRunId,
      test_run_case_id: testRunCaseId,
      project_id: projectId,
      ...updates,
    });
    return response;
  },

  /**
   * Bulk update test case execution status in a test run
   */
  bulkUpdateTestCaseExecution: async (
    testRunId,
    testRunCaseIds,
    projectId,
    updates,
  ) => {
    const response = await api.post("/testrun/bulk-update-execution", {
      test_run_id: testRunId,
      test_run_case_ids: testRunCaseIds,
      project_id: projectId,
      ...updates,
    });
    return response;
  },

  /**
   * Archive test run
   */
  archiveTestRun: async (testRunId, projectId) => {
    const response = await api.post("/testrun/archive", {
      test_run_id: testRunId,
      project_id: projectId,
    });
    return response;
  },

  /**
   * Restore archived test run
   */
  restoreTestRun: async (testRunId, projectId) => {
    const response = await api.post("/testrun/restore", {
      test_run_id: testRunId,
      project_id: projectId,
    });
    return response;
  },

  /**
   * Bulk archive test runs
   */
  bulkArchiveTestRuns: async (testRunIds, projectId) => {
    const response = await api.post("/testrun/bulk-archive", {
      test_run_ids: testRunIds,
      project_id: projectId,
    });
    return response;
  },

  /**
   * Bulk restore test runs
   */
  bulkRestoreTestRuns: async (testRunIds, projectId) => {
    const response = await api.post("/testrun/bulk-restore", {
      test_run_ids: testRunIds,
      project_id: projectId,
    });
    return response;
  },

  getTestCaseDetails: async (testRunId, testRunCaseId) => {
    const response = await api.post("/testruns/testcases/get", {
      test_run_id: testRunId,
      test_run_case_id: testRunCaseId,
    });
    return response;
  },

  updateAssignedTo: async (testRunId, testRunCaseId, assignedTo) => {
    const response = await api.post("/testruns/testcases/update-assignee", {
      test_run_id: testRunId,
      test_run_case_id: testRunCaseId,
      assigned_to: assignedTo,
    });
    return response;
  },
};
